import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  item: null,
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createStore({ commit }, item) {
    return this.$axios.$post('admin/stores/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeStore({ commit }, item) {
    return this.$axios.$delete(`admin/stores/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateStore({ commit }, item) {
    return this.$axios.$put(`admin/stores/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchStore({ commit }, id) {
    return this.$axios.$get(`admin/stores/${id}`).then((response) => {
      return response.data
    })
  },
  fetchStores({ commit }) {
    return this.$axios.$get('admin/stores').then((response) => {
      commit('load', response.data)
      return response.data
    })
  },
}
